export default "__VITE_ASSET__NApGahCO__"